// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__1L-rb","link":"nav_link__1Iusw","logo":"nav_logo__3PSWT"};